module.exports = __webpack_public_path__ + "static/NeueMontreal-Italic-16ed85e8fac4964a6972be129ea4168b.woff";